import { Box, Typography, Stack } from "@mui/material";
import { ITouchpoint } from "../../../../types";
import dayjs from "dayjs";
import { AdvisorInsightsItem } from "./AdvisorInsightsItem";
import { DisplayBoxBase } from "../../../../components/shared/StyledComponents";


export const AdvisorInsightsList = ({ section, touchpoints }: { section: string, touchpoints: ITouchpoint[] }) => {

    if (!touchpoints.length && section === "new") {
        return (
            <DisplayBoxBase
                className="white"
                sx={{
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                    py: 3
                }}
            >
                <Typography variant="body1" color="text.secondary" sx={{ textAlign: "center" }}>
                    There are no new questions to answer at this time.
                </Typography>
                <Typography variant="caption" color="text.secondary" sx={{ textAlign: "center" }}>
                    Check back later for new opportunities to provide feedback.
                </Typography>
            </DisplayBoxBase>
        )
    }

    return (
        <Stack direction="column" gap={2} mb={4}>

            {touchpoints.sort((a: any, b: any) => {
                return new Date(b.scheduled_at).getTime() - new Date(a.scheduled_at).getTime();
            }).map((touchpoint: any) => (
                <AdvisorInsightsItem key={touchpoint.uuid} touchpoint={touchpoint} />
            ))}

        </Stack>
    )
}